import { connect } from 'react-redux'

import BannerLayoutOne from 'components/home-page/views/sections/banner/layouts/one'

const mapStateToProps = (state, ownProps) => ({
  data: state.homePageRevision.revision.sections[ownProps.sectionId].data[0],
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme,
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  brandColor: state.theme.theme.brandColor
})

export default connect(mapStateToProps)(BannerLayoutOne)
